module.exports = __webpack_public_path__ + "img/line-icon-complete.448419e5.svg";